module.exports = __webpack_public_path__ + "img/版权登记ico.805db25e.png";